import React, { ReactElement } from 'react';
import { Footer } from '@novozymes/components';

const FooterWrapper = (): ReactElement => {
  return <Footer />;
};

export default FooterWrapper;
